<template>
  <el-form
      @submit.prevent="triggerFormSubmit"
      ref="refFormApplication"
      :model="model"
      class="common-form">
    <h2 class="text-[13px] font-semibold text-[#23569F] uppercase mb-6 leading-[1.5]">{{ $t('playerSetup.Application') }}</h2>
    <el-row justify="center" type="flex" >
      <div :class="!isLEDAvailable ? 'mt-8' : 'mt-0'">
        <div class="player-setup-display-application">
          <el-form-item
            prop="orientation"
            class="player-setup-application justify-items-center">
            <div :class="isLEDAvailable ? 'columns-2' : 'columns-3'">
              <div class="p-[15px] text-center">
                <el-radio
                  ref="singleApplicationRadio"
                  tabindex="1"
                  v-model="model.application"
                  :label="applications.APP_SINGLE"
                  class="
                    w-[200px]
                    h-[120px]!
                    rounded-xs
                    inline-block!
                    text-center
                    border
                    border-[#CCCCCC]">
                  <b class="block text-md font-normal text-black mb-2 mt-2">{{ $t('playerSetup.ApplicationSingleDisplay') }}</b>
                  <span class="border-black border-2 w-[80px] h-[46px] p-2 inline-block text-center bg-white">
                    <font-awesome-icon :style="{color: 'black'}" class="w-full h-full border-black" icon="fa-regular fa-face-smile" />
                  </span>
                </el-radio>
              </div>
              <div class="p-[15px] text-center">
                <el-radio
                  ref="mirroringApplicationRadio"
                  tabindex="2"
                  v-model="model.application"
                  :label="applications.APP_MIRRORING"
                  class="
                    w-[200px]
                    h-[120px]!
                    rounded-xs
                    inline-block!
                    text-center
                    border
                    border-[#CCCCCC]">
                  <b class="block text-md font-normal text-black mb-2 mt-2">{{ $t('playerSetup.ApplicationMirroring') }}</b>
                  <span class="inline-block text-center bg-white">
                    <span class="grid grid-cols-2 border-black border-l-2 border-t-2 w-[80px] text-center self-center">
                      <span class="h-[22px] text-center border-black border-r-2 border-b-2 p-[2px]">
                        <font-awesome-icon :style="{color: 'black'}" class="w-full h-[14px] border-black block" icon="fa-regular fa-face-smile" />
                      </span>
                      <span class="h-[22px] text-center border-black border-r-2 border-b-2 p-[2px]">
                        <font-awesome-icon :style="{color: 'black'}" class="w-full h-[14px] border-black block" icon="fa-regular fa-face-smile" />
                      </span>
                      <span class="h-[22px] text-center border-black pb-[2px] border-r-2 border-b-2 p-[2px]">
                        <font-awesome-icon :style="{color: 'black'}" class="w-full h-[14px] border-black block" icon="fa-regular fa-face-smile" />
                      </span>
                      <span class="h-[22px] text-center border-black border-r-2 border-b-2 p-[2px]">
                        <font-awesome-icon :style="{color: 'black'}" class="w-full h-[14px] border-black block" icon="fa-regular fa-face-smile" />
                      </span>
                    </span>
                  </span>
                </el-radio>
              </div>
              <div class="p-[15px] text-center">

                <el-radio
                  ref="videowallApplicationRadio"
                  tabindex="3"
                  v-model="model.application"
                  :label="applications.APP_VIDEOWALL"
                  :disabled="isDiscovery"
                  class="
                    w-[200px]
                    h-[120px]!
                    rounded-xs
                    inline-block!
                    text-center
                    border
                    border-[#CCCCCC]">
                  <span class="relative hint" v-show="isDiscovery">
                    <p class="absolute top-[-20px] font-medium text-xs">{{ $t('playerSetup.ApplicationAvailable')}} <a href="/plans" target="_blank">PREMIUM</a></p>
                  </span>
                  <b class="block text-md font-normal text-black mb-2 mt-2">{{ $t('playerSetup.ApplicationVideowall') }}</b>
                  <span class="display border-black border-2 w-[80px] h-[46px] p-2 inline-block text-center bg-white relative">
                    <font-awesome-icon :style="{color: 'black'}" class="w-full h-full border-black" icon="fa-regular fa-face-smile" />
                    <span class="display border-black border h-[44px] top-[0px] left-[calc(50%-1px)] absolute"></span>
                    <span class="display border-black border w-[78px] top-[calc(50%-1px)] left-[0px] absolute"></span>
                  </span>
                </el-radio>
              </div>
              <div
                class="p-[15px] text-center"
                v-if="isLEDAvailable">
                <el-radio
                  ref="ledApplicationRadio"
                  :disabled="!licenses.includes('systems')"
                  tabindex="4"
                  v-model="model.application"
                  :label="applications.APP_LED"
                  class="
                    w-[200px]
                    h-[120px]!
                    rounded-xs
                    inline-block!
                    text-center
                    border
                    border-[#CCCCCC]">
                  <b class="block text-md font-normal text-black mb-2 mt-2">LED</b>
                  <span class="display border-black border-2 w-[80px] h-[29px] p-[3px] inline-block text-center bg-white">
                    <font-awesome-icon :style="{color: 'black'}" class="w-full h-full border-black block" icon="fa-regular fa-face-smile" />
                  </span>
                  <p :class="[{ 'flex-row-reverse': isArabic }, 'absolute w-full flex items-center justify-center bottom-2.5']">
                    <span class="px-1 text-black text-xs">{{ $t('playerSetup.ApplicationAvailbleWithNote') }}
                    </span>
                    <player-setup-license-icon license="systems" />
                  </p>
                </el-radio>
              </div>
            </div>
          </el-form-item>
        </div>
        <p class="block text-xs input-hint text-center mt-3">{{ $t('playerSetup.SelectApplication') }}</p>
      </div>
    </el-row>
</el-form>
</template>

<script src="./player-setup-application.js"></script>
<style lang="scss" src="./player-setup-application.scss"></style>
